import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { ReactComponent as ArrowRightIcon } from "images/arrow-right-icon.svg";
import { UsersIcon, CurrencyDollarIcon, HeartIcon } from '@heroicons/react/24/solid'

const ThreeColumnContainer = styled.div`
  ${tw`mt-10 flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap lg:justify-center max-w-screen-lg mx-auto`}
`;
const Column = styled.div`
  ${tw`lg:w-1/3 max-w-xs`}
`;

const Card = styled.a`
  ${tw`flex flex-col items-center text-center h-96 mx-4 px-4 py-8 rounded transition-transform duration-300 hover:cursor-pointer transform hover:scale-105 `}
  .title {
    ${tw`mt-4 font-bold text-xl leading-none`}
  }

  .description {
    ${tw`mt-4 text-sm font-medium text-secondary-300`}
  }

  .link {
    ${tw`mt-auto inline-flex items-center pt-5 text-sm font-bold text-primary-300 leading-none hocus:text-primary-900 transition duration-300`}
    .icon {
      ${tw`ml-2 w-4`}
    }
  }
`;

export default () => {
  /*
   * This componets accepts a prop - `cards` which is an array of object denoting the cards. Each object in the cards array can have the following keys (Change it according to your need, you can also add more objects to have more cards in this feature component):
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  4) url - the url that the card should goto on click
   */
  return (
    <Container>
      <ContentWithPaddingXl>
        <ThreeColumnContainer>
          <Column>
            <Card href="#">
              <UsersIcon />
              <span className="title">Join</span>
              <p className="description">Making every child's potential a reality by engaging and empowering families and communities to advocate for all children.</p>
              <span className="link">
                <span>Learn More</span>
                <ArrowRightIcon className="icon" />
              </span>
            </Card>
          </Column>
          <Column>
            <Card href="#">
              <HeartIcon />
              <span className="title">Volunteer</span>
              <p className="description">Decades of research shows that when parents are involved, students perform better in school. Visit our Volunteer page for current opportunities.</p>
              <span className="link">
                <span>Learn More</span>
                <ArrowRightIcon className="icon" />
              </span>
            </Card>
          </Column>
          <Column>
            <Card href="#">
              <CurrencyDollarIcon />
              <span className="title">Donate</span>
              <p className="description">Bridging the financial gaps to support our campus, our teachers, and our students, with the goal to provide all students with the very BEST educational experiences.</p>
              <span className="link">
                <span>Learn More</span>
                <ArrowRightIcon className="icon" />
              </span>
            </Card>
          </Column>
        </ThreeColumnContainer>
      </ContentWithPaddingXl>
    </Container>
  );
};
